module.exports = __webpack_public_path__ + "static/img/snapbot-img.ba05119.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/snapbot-img.png
// module id = Psfw
// module chunks = 1